class comparisonChart extends HTMLElement {
    constructor() {
      super();
      this.productInputs = this.querySelectorAll('input[name^="compare_chart"]');
    }
    connectedCallback() {
      this.init();
      if (!localStorage.getItem('_comparison_chart_products')) {
        this.hideLoader();
      } else {
        this.setCartAttribute(localStorage.getItem('_comparison_chart_products'));
      }

      // Initialize Yotpo widgets after component loads
      this.initializeYotpoWidgets();
    }
  
    init() {
      this.productInputs?.forEach(input => {
        input.addEventListener('change', this.handleChange.bind(this));
      });

      // Add event listeners for remove buttons
      this.removeButtons = this.querySelectorAll('[data-remove-product]');
      this.removeButtons?.forEach(button => {
        button.addEventListener('click', this.handleRemoveProduct.bind(this));
      });

      // Add event listener for remove all button
      this.removeAllButton = this.querySelector('.btn-remove-all');
      if (this.removeAllButton) {
        this.removeAllButton.addEventListener('click', this.handleRemoveAll.bind(this));
      }

      this.stickyCompareHeader();
      this.highlightCurrentProduct();
    }
  
    handleChange(e) {
      e.preventDefault();
      let handle_array = Array.from(this.productInputs).filter(input => input.checked).map(input => input.value);
      let handleData = handle_array.join(", ");
      this.setLocalStorage(handleData);
    }

    handleRemoveProduct(e) {
      e.preventDefault();
      console.log('handleRemoveProduct');
      setTimeout(() => {
        this.showLoader();
      }, 10);
      const productHandle = e.currentTarget.dataset.removeProduct?.trim();

      if (!productHandle) return;

      

      setTimeout(() => {
        // Get current  products from localStorage
        const currentProducts = localStorage.getItem('_comparison_chart_products') || '';
        let productArray = currentProducts.split(',').map(handle => handle.trim()).filter(handle => handle.length > 0);

        // Remove the specific product (case-insensitive and trimmed comparison)
        productArray = productArray.filter(handle => handle.trim().toLowerCase() !== productHandle.toLowerCase());

        const updatedProducts = productArray.join(', ');
        this.setLocalStorage(updatedProducts);
      }, 50);
    }

    handleRemoveAll(e) {
      e.preventDefault();

      // Show loader immediately when button is clicked
      setTimeout(() => {
        this.showLoader();
      }, 10);

      // Small delay to ensure loader is visible before starting the update process
      setTimeout(() => {
        // Clear all products from localStorage and cart
        this.setLocalStorage('');
      }, 50);
    }
  
    renderData = async () => {
      try {
        const response = await fetch(`${location.origin}${location.pathname}?section_id=${this.dataset.sectionId}`);
        const data = await response.text();

        const html = new DOMParser().parseFromString(data, 'text/html');
        const sourceQty = html.querySelector('comparison-chart');
        this.innerHTML = sourceQty.innerHTML;

        // Show loader after a small delay to ensure it overrides the CSS default
        setTimeout(() => {
          this.showLoader();
        }, 10);

        this.productInputs = this.querySelectorAll('input[name^="compare_chart"]');
        this.removeButtons = this.querySelectorAll('[data-remove-product]');
        this.removeAllButton = this.querySelector('.btn-remove-all');

        this.init();

        this.removeCartAttribute();

        // Keep loader visible during Yotpo initialization, then hide
        setTimeout(() => {
          this.hideLoader();
        }, 1500); // Keep loader visible for 1.5 seconds after content loads

        // Reinitialize Yotpo widgets asynchronously (doesn't block UI)
        this.initializeYotpoWidgets();
      } catch (error) {
        console.error('Error in renderData:', error);
        this.hideLoader(); // Hide loader on error
      }
    }
  
    setLocalStorage(productHandle) {
      localStorage.setItem('_comparison_chart_products', productHandle); 
      this.productHandles = productHandle;
      this.setCartAttribute(productHandle);
    }
  
    setCartAttribute = async (productHandle) => {
      let body = {attributes: {'_comparison_chart_products': productHandle || null}};

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
      })
      .then(response => {
        this.renderData();
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
        this.hideLoader(); // Hide loader on error
      });
    }
  
    removeCartAttribute() {
      let body = { attributes: {} };
      body.attributes['_comparison_chart_products'] = null;
    
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
      .then((response) => response.json())
      .catch((error) => console.error('Error:', error));
    }
  
    highlightCurrentProduct() {
      const currentProductHandle = localStorage.getItem('_comparison_chart_product_current');
      const comparisonProducts = localStorage.getItem('_comparison_chart_products');
      
      if (currentProductHandle && comparisonProducts) {
        const comparisonProductArray = comparisonProducts.split(',').map(handle => handle.trim());
        
        if (comparisonProductArray.includes(currentProductHandle)) {
          // Find the index of the current product in the comparison array
          const currentIndex = comparisonProductArray.indexOf(currentProductHandle);
          
          // Get all product row table cells
          const productRowCells = this.querySelectorAll('.product-row td');
          
          // Add 'current' class to the corresponding cell
          if (productRowCells[currentIndex]) {
            productRowCells[currentIndex].classList.add('current');
          }
        }
      }
    }
  
    stickyCompareHeader() {

      let header = document.querySelector('.section-header');
      let isScrolling; // Timer for debounce
      window.addEventListener('load', () => {
        const headerHeight = header ? header.clientHeight : 0;
        this.style.setProperty('--top-position', `${(this.getBoundingClientRect().top * -1) + headerHeight}px`);
        window.addEventListener('scroll', () => {
          this.classList.remove('is-sticky-active');
          clearTimeout(isScrolling);

            if(this.getBoundingClientRect().top < 0) {
              this.classList.add('is-sticky');
              isScrolling = setTimeout(() => {
                this.classList.add('is-sticky-active');
                const headerHeight = header ? header.clientHeight : 0;
                this.style.setProperty('--top-position', `${(this.getBoundingClientRect().top * -1) + headerHeight}px`);
              },100);
            } else {
              this.classList.remove('is-sticky');
              this.classList.remove('is-sticky-active');
              this.style.setProperty('--top-position', `0`);
            }

        });
      })
    }

    initializeYotpoWidgets() {
      // Reinitialize Yotpo widgets after dynamic content loads
      setTimeout(() => {
        try {
          if (typeof yotpo !== 'undefined') {
            if (yotpo.initWidgets) {
              yotpo.initWidgets();
            }
            if (yotpo.refreshWidgets) {
              yotpo.refreshWidgets();
            }
            // Try to initialize specific widgets
            if (yotpo.initElement) {
              const yotpoElements = this.querySelectorAll('.yotpo-widget-instance');
              yotpoElements.forEach(element => {
                yotpo.initElement(element);
              });
            }
          }

          // Fallback: dispatch custom event for Yotpo
          window.dispatchEvent(new Event('yotpo-ready'));

        } catch (error) {
          console.log('Yotpo initialization attempt failed:', error);

          // Fallback: show basic review indicator
          this.showReviewFallback();
        }
      }, 1500); // Increased timeout to ensure Yotpo script is loaded
    }

    showReviewFallback() {
      // Show fallback review indicators if Yotpo fails to load
      const reviewWidgets = this.querySelectorAll('.yotpo-widget-instance');
      reviewWidgets.forEach(widget => {
        if (!widget.innerHTML.trim() || widget.innerHTML.includes('Review highlights for product')) {
          widget.innerHTML = '<small class="text-muted">⭐ Customer Reviews</small>';
        }
      });
    }

    showLoader() {
      const loader = this.querySelector('[data-compare-loader]');
      if (loader) {
        loader.style.display = 'flex !important';
        loader.style.visibility = 'visible !important';
        loader.style.opacity = '1 !important';
        this.style.position = 'relative';
      }
    }

    hideLoader() {
      
      const loader = this.querySelector('[data-compare-loader]');
      if (loader) {
        loader.style.display = 'none';
        loader.style.visibility = 'hidden';
        loader.style.opacity = '0';
      }
    }
  }
  customElements.define('comparison-chart', comparisonChart);